import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private accessKey = 'accessToken';
  private refreshKey = 'refreshToken';
  private userKey = 'authUser';

  getToken() {
    return localStorage.getItem(this.accessKey);
  }

  getRefreshToken() {
    return localStorage.getItem(this.refreshKey);
  }

  setTokens(accessToken: string, refreshToken?: string) {
    if (accessToken) localStorage.setItem(this.accessKey, accessToken);
    if (refreshToken) localStorage.setItem(this.refreshKey, refreshToken);
  }

  setUser(user: any) {
    if (user) localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser<T = any>(): T | null {
    const raw = localStorage.getItem(this.userKey);
    return raw ? (JSON.parse(raw) as T) : null;
  }

  clear() {
    localStorage.removeItem(this.accessKey);
    localStorage.removeItem(this.refreshKey);
    localStorage.removeItem(this.userKey);
  }
}
